export const pageTitle = title => {
  return (document.title = title + ' - Ignite Sports Pavilion | Premier Padel & Sports Club');
};
